import Link from "next/link";
import styled from "styled-components";
import { useRouter } from "next/router";

const Header = styled.header`
  width: 100vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: white;
`;

const Wrapper = styled.div`
  width: 1000px;
  margin: 0 auto;
  @media screen and (max-width: 1200px) {
    width: 80%;
  }
  @media screen and (max-width: 1000px) {
    width: 90%;
  }
`;

const Ul = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Li = styled.li`
  display: inline-block;
  margin: 1rem 0;
`;

const A = styled.a`
  color: #a6a6a6;
  text-transform: uppercase;
  font-size: 2.3rem;
  text-align: center;
  &.active {
    color: black;
  }
  img {
    transform: translateX(-15px);
    max-width: 200px;
  }
`;

export const DesktopHeader = () => {
  const router = useRouter();

  return (
    <Header>
      <Wrapper>
        <Ul>
          <Li>
            <Link href="/shop">
              <A
                className={
                  router.pathname.split("/")[1].includes("shop") ? "active" : ""
                }
              >
                Shop
              </A>
            </Link>
          </Li>
          <Li>
            <Link href="/lookbook">
              <A
                className={
                  router.pathname.split("/")[1].includes("lookbook")
                    ? "active"
                    : ""
                }
              >
                Lookbook
              </A>
            </Link>
          </Li>
          <Li>
            <Link href="/">
              <A>
                <img src="/images/translogo_gray.png" alt="Faceguy logo" />
              </A>
            </Link>
          </Li>
          <Li>
            <Link href="/">
              <A
                className={router.pathname.split("/")[1] === "" ? "active" : ""}
              >
                Home
              </A>
            </Link>
          </Li>
          <Li>
            <Link href="/contact">
              <A
                className={
                  router.pathname.split("/")[1].includes("contact")
                    ? "active"
                    : ""
                }
              >
                Cont*ct
              </A>
            </Link>
          </Li>
        </Ul>
      </Wrapper>
    </Header>
  );
};
